import _ from 'lodash';
import React from 'react';
import Modal from 'react-bootstrap/Modal';
import { clickToShare, socialMedia } from '../../../../../shared/click-to-share';

require('moment-timezone');

export default class SchedulePromptToShareModal extends React.Component {
  constructor(props, context) {
    super(props, context);

    this.state = {
      show: false,
      timeAndDate: null,
      email: null,
      url: null,
      wireId: null,
    };

    this.dismiss = this.dismiss.bind(this);
    this.present = this.present.bind(this);
  }

  present({
    shares: { email }, url, autoPublishAt, wireId,
  }) {
    const timeAndDate = (autoPublishAt && autoPublishAt.isValid()) ? autoPublishAt.tz('Australia/Sydney').format('hh:mm a LL zz') : null;
    this.setState({
      timeAndDate, email, url, wireId, show: true,
    });
  }

  dismiss() {
    this.setState({ show: false }, () => (window.location = '/feeds/latest'));
  }

  render() {
    return (
      <Modal
        centered="true"
        dialogAs="article"
        dialogClassName="vertical"
        show={this.state.show}
        backdrop="static"
      >
        <Modal.Body as="section" className="left">
          <span>
            <svg className="icon"><use href="#schedule" /></svg>
          </span>
          <strong className="title">scheduled</strong>
          <p className="main">Congratulations, your wire has been scheduled for</p>
          <p className="time-date">{this.state.timeAndDate}</p>
          <p className="secondary">We&apos;ll send you an email once your wire has successfully published.</p>
          <div className="flex-box-column">
            <button type="button" className="btn btn-primary-inverted" onClick={this.dismiss}>
              thanks, take me to latest feed
            </button>
            <a href="https://livewiremarkets1.typeform.com/to/VVssyp" target="_blank" rel="noopener noreferrer" className="feedback">Provide feedback</a>
          </div>
        </Modal.Body>
        <Modal.Footer as="section" className="right">
          <strong className="title">get more views</strong>
          <p className="main">Once your wire has been published, don&apos;t forget to share it across your other channels to help drive more traffic to your wire.</p>
          <span className="icon-head">quick share links</span>
          <div className="flex-box-row">
            <a className="link-secondary" href={this.state.email} target="_self">
              <span className="icon-lw icon-lw-email" />
            </a>
            {_.map(socialMedia, _.toLower).map(d => (
              <a
                key={d}
                className="link-secondary"
                href="#"
                onClick={() => clickToShare({ wireId: this.state.wireId, source: d, medium: 'scheduled-prompt' })}
              >
                <span className={`icon-lw icon-lw-${d}`} />
              </a>
            ))}
            <a className="link-secondary" href={this.state.url} target="_blank" rel="noopener noreferrer">
              <span className="icon-lw icon-lw-link-horizontal" />
            </a>
          </div>
        </Modal.Footer>
      </Modal>
    );
  }
}
